<div class="col-xs-12" ng-show="tiposOcorrencias">
  <div class="ibox float-e-margins">
    <div class="ibox-title">Resultados</div>
    <div class="ibox-content">
      <small ng-show="tiposOcorrencias.length == 0">Nenhum resultado encontrado!</small>
      <table class="table table-hover table-striped" ng-show="tiposOcorrencias.length > 0">
        <thead>
          <tr>
            <th>Descrição</th>
            <th class="text-center">Tipo</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="tipo in tiposOcorrencias track by $index" ng-class="{'inactive-row': !tipo.ativo}">
            <td class="vertical-middle">
              {{::tipo.descricao | capitalize}}
              <br>
              <small><i>{{::tipo.nome_cientifico | humanize}}</i></small>
            </td>
            <td class="vertical-middle text-center">
              <span class="label bg-neutro alert-icon">
                <i agro-icon-historico historico="{tipo: tipo.tp_ocorrencia}" uib-tooltip="{{tipo.tp_ocorrencia_to_pt_br}}" tooltip-append-to-body="true"></i>
              </span>
              <small ng-if="tipo.subtipo"><br>{{tipo.subtipo_pt_br}}</small>
            </td>
            <td class="vertical-middle text-center">
              <button ng-if="permissions.tipos_ocorrencia.canManage"
                type="button"
                class="btn btn-link btn-sm pull-right"
                uib-tooltip="{{tipo.ativo ? 'Desativar' : 'Ativar'}}"
                ng-click="toggleTipo(tipo)"
              >
                <i class="fa" ng-class="{
                  'fa-square-o': !tipo.ativo,
                  'fa-check-square-o': tipo.ativo
                }"></i>
              </button>
              <span ng-if="!permissions.tipos_ocorrencia.canManage">
                {{::tipo.ativo ? 'Ativo' : 'Inativo'}}
              </span>
            </td>
            <td class="vertical-middle text-right">
              <div class="btn btn-primary btn-sm" ng-click="edit(tipo)" ng-if="permissions.tipos_ocorrencia.canManage" uib-tooltip="Editar">
                <i class="glyphicon glyphicon-pencil"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-right">
        <ng-include src="'views/_pagination.html'"></ng-include>
      </div>
    </div>
  </div>
</div>
